export default __webpack_public_path__ + "static/media/ISKO CLASS 3 SYLLABUS.a3f12fa5.pdf";